import { split } from "ramda"

export const splitByDot = split('.');

export const splitBySpace = split(' ');

export const splitBySlash = split('/');

export const splitByBackslash = split('\\');


